import React, { useContext } from "react";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import ProfileContactInfo from "./ProfileContactInfo";

const ProfileContactInfoTopRight = ({ language, documentType }) => {
  const { documentLayout } = useContext(ResourceContext);

  if (documentLayout && documentLayout.infoBoxPlacement !== "RIGHT") {
    return null;
  }
  return (
    <ProfileContactInfo language={language} documentType={documentType} />
  );
};

export default ProfileContactInfoTopRight;
